export class PaginazioneDTO {
  // The number of elements in the page
  risultatiPagina: number = 0;
  // The total number of elements
  numeroRisTotali: number = 0;
  // The total number of pages
  numeroPagTotali: number = 0;
  // The current page number
  numeroPagina: number = 0;
}
